import React from "react";
import { Link } from "react-router-dom";
import Icon from "../components/ui/Icon";

const NotFoundPage = () => (
  <div className="relative min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 overflow-hidden">
    {/* Animated floating elements */}
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-blue-200/30 rounded-full blur-xl animate-pulse"></div>
      <div className="absolute top-3/4 right-1/4 w-24 h-24 bg-indigo-200/40 rounded-full blur-lg animate-pulse delay-1000"></div>
      <div className="absolute bottom-1/4 left-1/3 w-16 h-16 bg-slate-200/50 rounded-full blur-md animate-pulse delay-500"></div>
    </div>

    {/* Decorative geometric shapes */}
    <svg
      className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none"
      viewBox="0 0 800 600"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M100 100L200 150L150 250L50 200Z" fill="#3B82F6" />
      <path d="M600 80L750 120L700 200L550 160Z" fill="#1E40AF" />
      <circle cx="400" cy="450" r="80" fill="#60A5FA" />
      <path d="M650 400L750 450L700 550L600 500Z" fill="#93C5FD" />
    </svg>

    {/* Main content */}
    <div className="relative z-10 flex flex-col items-center px-8 py-16 bg-white/90 rounded-3xl shadow-2xl backdrop-blur-xl border border-blue-100/50 max-w-2xl mx-4">
      {/* 404 Number with floating effect */}
      <div className="relative mb-8">
        <h1 className="text-9xl md:text-[12rem] font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 via-indigo-600 to-slate-700 drop-shadow-2xl animate-pulse">
          404
        </h1>
        <div className="absolute -top-4 -right-4 w-8 h-8 bg-blue-500 rounded-full animate-bounce delay-300"></div>
        <div className="absolute -bottom-2 -left-2 w-6 h-6 bg-indigo-400 rounded-full animate-bounce delay-700"></div>
      </div>

      {/* Error message */}
      <div className="text-center mb-10">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">Page Not Found</h2>
        <p className="text-lg text-slate-600 leading-relaxed max-w-md">
          The page you're looking for seems to have wandered off into the digital void. Don't worry, it happens to the
          best of us!
        </p>
      </div>

      {/* Action buttons */}
      <div className="w-full max-w-md">
        <Link
          to="/"
          className="flex items-center justify-center gap-2 px-8 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl font-semibold shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 text-center hover:from-blue-700 hover:to-indigo-700"
        >
          <Icon icon="home" /> Go Home
        </Link>
      </div>
    </div>

    {/* Subtle footer */}
    <div className="absolute bottom-8 text-center">
      <p className="text-slate-500 text-sm">Lost? Return Home, our navigation bar will guide you back to safety.</p>
    </div>
  </div>
);

export default NotFoundPage;
